<template>
  <div
    class="relative flex items-center justify-center rounded-full border-2 border-solid"
    :class="memberClass"
  >
    <div
      class="flex h-7 w-7 items-center justify-center rounded-full text-sm font-bold"
    >
      {{ userAccountNameAbbrev }}
    </div>
    <div
      class="absolute -right-1 bottom-0 flex h-3 w-3 items-center justify-center rounded-full"
      :class="memberBadgeClass"
    >
      <IconAwardGold
        v-if="userMemberType === EnumMemberType.GOLD"
        class="h-2 w-2 text-white"
      />
      <IconAwardSliver
        v-else-if="userMemberType === EnumMemberType.SILVER"
        class="h-2 w-2 text-white"
      />
      <IconAwardVip
        v-else-if="userMemberType === EnumMemberType.VIP"
        class="h-2 w-2 text-white"
      />
      <IconAwardRegular v-else class="h-2 w-2 text-white" />
    </div>
  </div>
</template>

<script setup lang="ts">
  const profileStore = useProfileStore();
  const { userAccountNameAbbrev, userMemberType } = storeToRefs(profileStore);

  const memberClass = computed((): string => {
    switch (userMemberType.value) {
      case EnumMemberType.GOLD:
        return 'bg-orange-100 border-orange-200 text-orange-400';
      case EnumMemberType.SILVER:
        return 'bg-adv_blue-100 border-adv_blue-200 text-adv_blue-400';
      case EnumMemberType.VIP:
        return 'bg-brown-100 border-brown-200 text-brown-400';
      case EnumMemberType.REGULAR:
        return 'bg-cyan-100 border-cyan-200 text-cyan-400';
      default:
        return 'bg-cyan-100 border-cyan-200 text-cyan-400';
    }
  });

  const memberBadgeClass = computed((): string => {
    switch (userMemberType.value) {
      case EnumMemberType.GOLD:
        return 'bg-orange-400';
      case EnumMemberType.SILVER:
        return 'bg-adv_blue-400';
      case EnumMemberType.VIP:
        return 'bg-brown-400';
      case EnumMemberType.REGULAR:
        return 'bg-cyan-400';
      default:
        return 'bg-cyan-400';
    }
  });
</script>
